module.exports = window["core-js/modules/es.regexp.exec.js"];